export default __webpack_public_path__ + "static/media/nft2.9bd0001c.jpg";